(function () {

  function getMinZoom(visibility) {

    switch ((visibility || "").toLowerCase()) {

      case "global":
        return 2;

      case "regional":
        return 5;

      case "local":
        return 8;

      default:
        return 2;

    }

  }

  function getMaxZoom(visibility) {

    switch ((visibility || "").toLowerCase()) {

      case "global":
        return 18;

      case "regional":
        return 18;

      case "local":
        return 18;

      default:
        return 18;

    }

  }

  window.PathfinderIndexAdapter = {

   buildMapData: function () {

  if (!window.PATHFINDER_INDEX) {
    return [];
  }

  console.log("PATHFINDER_INDEX records:", window.PATHFINDER_INDEX.length);

  const filtered = window.PATHFINDER_INDEX.filter(function (record) {

  const type =
    (record.type || "").toLowerCase();

  return (
    record.latitude &&
    record.longitude &&
    (
      type === "country" ||
      type === "region" ||
      type === "international" ||
      type === "national" ||
      type === "poi"
    )
  );

});

  console.log("Records after filter:", filtered.length);

  return filtered.map(function (record) {

    const zoom = Number(record.mapZoom || 2);

    return {

        id: record.poiId || record.id,

        level: (record.type || "").toLowerCase(),

        name: record.title,

        summary: record.summary || "",

        lat: Number(record.latitude),

        lng: Number(record.longitude),

        image: record.image || null,

        destinationURL: record.url || "",

        minZoom:
  (function () {

    switch ((record.type || "").toLowerCase()) {

      case "country":
      case "international":
        return 0;

      case "national":
        return 3;

      case "region":
      case "poi":
        return 4;

      default:
        return 2;

    }

  })(),

maxZoom: 18,

        links: record.referenceUrl
          ? [{
              label: record.referenceTitle || "Learn More",
              url: record.referenceUrl
            }]
          : [],

        type: record.type || "",

        category: record.poiCategory || "",

        searchTags: record.searchTags || ""

           };

    });

    }

  };

})();